const createRoute = (name = '/', params = {}, query = {}) => ({
  name,
  params,
  query
})

export const createViewRoute = (notification) => {
  const stateRouteMap = (type, id) => {
    if (type === 'Demand') {
      return {
        consulted_demand: createRoute('DemandDetail', { demandId: notification.relevant_id })
      }
    }
    return {
      create_manager: createRoute('Workspace'),
      applying: createRoute('ProjectDetail', { projectId: id }, { action: 'open_drawer' }),
      apply_accepted: createRoute('ProjectDetail', { projectId: id }),
      apply_rejected: createRoute('ProjectDetail', { projectId: id }),
      applying_for_manager: createRoute('ProjectManagerDetail', { projectManagerId: id }),
      invited: createRoute('ProjectDetail', { projectId: id }),
      accept_invite: createRoute('ProjectDetail', { projectId: id }),
      reject_invite: createRoute('ProjectDetail', { projectId: id }),
      removed: createRoute('ProjectDetail', { projectId: id })
    }
  }
  const type = notification.relevant_type
  const id = notification.relevant_id
  const route = stateRouteMap(type, id)[notification.scene] || createRoute('Workspace')
  return route
}
